/* Momuna · Home (18-10-2026)
   - [data-mm-luces]: brillo que sigue al dedo/mouse sobre la tarjeta "Lo nuevo". Solo transform,
     un requestAnimationFrame por movimiento (nunca un bucle permanente). Al verse por primera vez
     marca .is-visto para que los destellos hagan dos pasadas solos.
   - [data-mm-video]: el video del anuncio no baja nada hasta que se ve; se pausa al salir. */
(function () {
  'use strict';
  var reducido = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;

  function luces(el) {
    var glow = el.querySelector('.mm-nuevo__glow'), x = 0, y = 0, pend = false, apagar;
    if (!glow) return;
    function pintar() { pend = false; glow.style.transform = 'translate3d(' + x + 'px,' + y + 'px,0)'; }
    function mover(e) {
      var r = el.getBoundingClientRect();
      x = e.clientX - r.left; y = e.clientY - r.top;
      el.classList.add('is-luz');
      clearTimeout(apagar);
      apagar = setTimeout(function () { el.classList.remove('is-luz'); }, 1400);
      if (!pend) { pend = true; requestAnimationFrame(pintar); }
    }
    if (!reducido) el.addEventListener('pointermove', mover, { passive: true });
    el.addEventListener('pointerleave', function () { clearTimeout(apagar); el.classList.remove('is-luz'); });
  }

  function video(v) {
    var cargado = false;
    if (!('IntersectionObserver' in window)) return;
    new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        if (e.isIntersecting) {
          if (!cargado) {
            cargado = true;
            v.querySelectorAll('source[data-src]').forEach(function (s) { s.src = s.getAttribute('data-src'); });
            v.load();
          }
          var p = v.play(); if (p && p.then) p.then(function () { v.classList.add('is-play'); }).catch(function () {});
        } else if (cargado) { v.pause(); }
      });
    }, { rootMargin: '120px' }).observe(v);
  }

  function iniciar() {
    var io = 'IntersectionObserver' in window ? new IntersectionObserver(function (es, o) {
      es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-visto'); o.unobserve(e.target); } });
    }, { threshold: 0.35 }) : null;
    document.querySelectorAll('[data-mm-luces]').forEach(function (el) { luces(el); if (io) io.observe(el); });
    if (!reducido) document.querySelectorAll('[data-mm-video]').forEach(video);
    /* 19-10-2026: mosquitos repelidos de "Lo más pedido": animan solo mientras la tarjeta está a la vista */
    var fx = document.querySelectorAll('[data-mm-fx]');
    if (fx.length && !reducido) {
      if (!('IntersectionObserver' in window)) { fx.forEach(function (el) { el.classList.add('is-visto'); }); }
      else { var iof = new IntersectionObserver(function (es) { es.forEach(function (e) { e.target.classList.toggle('is-visto', e.isIntersecting); }); }, { rootMargin: '80px' }); fx.forEach(function (el) { iof.observe(el); }); }
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', iniciar); else iniciar();
})();
